import { GetEnrollmentFilterKey } from 'types/enrollment/enrollment';

export const enrollmentFilterFields: Record<GetEnrollmentFilterKey, GetEnrollmentFilterKey> = {
    status: 'status',
    fromYear: 'fromYear',
    toYear: 'toYear',
};
